// Source: https://docs.databricks.com/sql/language-manual/sql-ref-reserved-words.html
export default [
  "ANTI",
  "CROSS",
  "EXCEPT",
  "FULL",
  "INNER",
  "INTERSECT",
  "JOIN",
  "LATERAL",
  "LEFT",
  "MINUS",
  "NATURAL",
  "ON",
  "RIGHT",
  "SEMI",
  "UNION",
  "USING",
  "NULL",
  "DEFAULT",
  "TRUE",
  "FALSE",
  "BUILTIN",
  "SESSION",
  "INFORMATION_SCHEMA",
  "ALL",
  "ALTER",
  "AND",
  "ANY",
  "ARRAY",
  "AS",
  "AT",
  "AUTHORIZATION",
  "BETWEEN",
  "BOTH",
  "BY",
  "CASE",
  "CAST",
  "CHECK",
  "COLLATE",
  "COLUMN",
  "COMMIT",
  "CONSTRAINT",
  "CREATE",
  "CROSS",
  "CUBE",
  "CURRENT",
  "CURRENT_DATE",
  "CURRENT_TIME",
  "CURRENT_TIMESTAMP",
  "CURRENT_USER",
  "DELETE",
  "DESCRIBE",
  "DISTINCT",
  "DROP",
  "ELSE",
  "END",
  "ESCAPE",
  "EXCEPT",
  "EXISTS",
  "EXTERNAL",
  "EXTRACT",
  "FALSE",
  "FETCH",
  "FILTER",
  "FOR",
  "FOREIGN",
  "FROM",
  "FULL",
  "FUNCTION",
  "GLOBAL",
  "GRANT",
  "GROUP",
  "GROUPING",
  "HAVING",
  "IN",
  "INNER",
  "INSERT",
  "INTERSECT",
  "INTERVAL",
  "INTO",
  "IS",
  "JOIN",
  "LEADING",
  "LEFT",
  "LIKE",
  "LOCAL",
  "NATURAL",
  "NO",
  "NOT",
  "NULL",
  "OF",
  "ON",
  "ONLY",
  "OR",
  "ORDER",
  "OUT",
  "OUTER",
  "OVERLAPS",
  "PARTITION",
  "POSITION",
  "PRIMARY",
  "RANGE",
  "REFERENCES",
  "REVOKE",
  "RIGHT",
  "ROLLBACK",
  "ROLLUP",
  "ROW",
  "ROWS",
  "SELECT",
  "SESSION_USER",
  "SET",
  "SOME",
  "START",
  "TABLE",
  "TABLESAMPLE",
  "THEN",
  "TIME",
  "TO",
  "TRAILING",
  "TRUE",
  "TRUNCATE",
  "UNION",
  "UNIQUE",
  "UNKNOWN",
  "UPDATE",
  "USER",
  "USING",
  "VALUES",
  "WHEN",
  "WHERE",
  "WINDOW",
  "WITH",
];
